window.initFaqGradient = (options = {
    blockClass,
    circleGradientClass,
    color
}) => {
    const block = $(`.${options.blockClass}`);
    const circleGradient = $(`.${options.circleGradientClass}`);

    block.mousemove((event) => {
        const windowWidth = block.innerWidth();
        const windowHeight = block.innerHeight();

        const mousePosX = event.pageX - block.offset().left;
        const mousePosY = event.pageY - block.offset().top;
        
        mouseXpercentage = Math.round(mousePosX / windowWidth * 100);
        mouseYpercentage = Math.round(mousePosY / windowHeight * 100);
        
        circleGradient.css(
            'background',
            'radial-gradient(400px 400px at ' + mouseXpercentage + '% ' + mouseYpercentage + `%, ${options.color}80, ${options.color}40, transparent)`
        );
    });
    block.mouseleave((e) => {
        circleGradient.removeAttr("style");
    });
}
